import httpClient from "Api/httpClient";

const END_POINT = "/entity_phones";

const getEntityPhones = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

const getEntityPhone = (entity_phones_id) => {
    if (!entity_phones_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + entity_phones_id;
    return httpClient.get(SINGLE_END_POINT);
};

const printEntityPhone = (entity_phones_id) => {
    if (!entity_phones_id) return;
    const SINGLE_END_POINT = END_POINT + "/print?entity_phones_id=" + entity_phones_id;
    return httpClient.get(SINGLE_END_POINT);
};

const createEntityPhones = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};

const updateEntityPhones = (payload, entity_phones_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + entity_phones_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteEntityPhones = (entity_phones_id, new_prime_entity_phones_id) => {
    new_prime_entity_phones_id = new_prime_entity_phones_id ? "/" + new_prime_entity_phones_id : "";
    const DELETE_END_POINT = END_POINT + "/" + entity_phones_id + new_prime_entity_phones_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

export { getEntityPhones, getEntityPhone, printEntityPhone, createEntityPhones, updateEntityPhones, deleteEntityPhones };
